export enum NonLeakNoiseSource {
  EnvNoise = 'ENV_NOISE',
  Fountain = 'FOUNTAIN',
  Irrigation = 'IRRIGATION',
  Pump = 'PUMP',
  Prv = 'PRV',
  WaterUsage = 'WATER_USAGE',
  Other = 'OTHER',
  Unknown = 'UNKNOWN',
}
